const ImageWithTextSlider = () => {
  const sections = document.querySelectorAll('.cstm-image-with-text-slider');

  if(sections.length === 0) return;

  sections.forEach(section => {
    const slider = section.querySelector('.image-with-text-slider');
    const prev = section.querySelector('.slider-nav.prev');
    const next = section.querySelector('.slider-nav.next');
    const pagination = section.querySelector('.slider-pagination');

    const options = {
      slidesPerView: 1,
      autoHeight: true,
      spaceBetween: 20,
      pagination: {
        el: pagination,
        clickable: true
      },
      navigation: {
        prevEl: prev,
        nextEl: next
      }
    }

    const swiper = new Swiper(slider, options);
  });
}

window.addEventListener('DOMContentLoaded', ImageWithTextSlider);
window.addEventListener('shopify:section:load', ImageWithTextSlider);
window.addEventListener('shopify:section:unload', ImageWithTextSlider);
window.addEventListener('shopify:section:select', ImageWithTextSlider);
window.addEventListener('shopify:section:deselect', ImageWithTextSlider);
window.addEventListener('shopify:section:reorder', ImageWithTextSlider);
window.addEventListener('shopify:block:load', ImageWithTextSlider);
window.addEventListener('shopify:block:unload', ImageWithTextSlider);
window.addEventListener('shopify:block:select', ImageWithTextSlider);
window.addEventListener('shopify:block:deselect', ImageWithTextSlider);


const ClientCarousel = () => {
  const sections = document.querySelectorAll('.cstm-client-carousel');

  if(sections.length === 0) return;

  sections.forEach(section => {
    const slider = section.querySelector('.image-slider');

    const options = {
      slidesPerView: 'auto',
      spaceBetween: 40,
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      freeMode: true,
      speed: 5000
    }

    const swiper = new Swiper(slider, options)
  });
}

window.addEventListener('DOMContentLoaded', ClientCarousel);
window.addEventListener('shopify:section:load', ClientCarousel);
window.addEventListener('shopify:section:unload', ClientCarousel);
window.addEventListener('shopify:section:select', ClientCarousel);
window.addEventListener('shopify:section:deselect', ClientCarousel);
window.addEventListener('shopify:section:reorder', ClientCarousel);
window.addEventListener('shopify:block:load', ClientCarousel);
window.addEventListener('shopify:block:unload', ClientCarousel);
window.addEventListener('shopify:block:select', ClientCarousel);
window.addEventListener('shopify:block:deselect', ClientCarousel);